// KL - full aircond price list.
const content = {
    slug: 'aircond-service-price',
    title: (c) => `Aircond Service Price in KL (${new Date().getFullYear()}) | Full Price List`,
    description: (c) =>
        `Aircond service prices in Kuala Lumpur: general service ${c.money(c.tables.general[0].wall)}, chemical wash ${c.money(c.tables.chemicalWash[0].wall)}, overhaul, gas top up and packages.`,
    eyebrow: 'KL · Price list',
    h1: 'Aircond Service Price List for KL',
    lead: 'Every service, every unit count, wall-mounted and ceiling cassette - in one place. Prices include transport; nothing is added on the day without your agreement.',
    image: 'blog/living/aircon/repairman-doing-air-conditioner-service.jpg',
    imageAlt: 'Aircond technician servicing a unit in a KL home',
    facts: ['Prices in RM', 'Transport included', 'Up to 2.0hp wall units'],
    ctaLabel: 'See the full price list',
    priceTitle: 'Full price list',
    priceIntro: 'Wall-mounted prices cover units up to 2.0hp; larger wall units are priced at the cassette rate.',
    panel: { type: 'priceTable' },
    sections: [
        {
            title: 'How our prices compare in KL',
            paragraphs: [
                'Advertised aircond general service in the Klang Valley typically costs RM80 to RM120 per unit, and chemical wash RM120 to RM180. We price at or below the bottom of those ranges, and we bring the per-unit price down further when you service several units at once.',
                'Watch out for very low headline prices that become expensive on the day - a "RM50 service" that adds a gas top up to every visit, or a separate transport fee. Our listed price is the price.',
            ],
        },
        {
            title: 'What a typical KL home pays',
            tone: 'muted',
            cards: [
                { title: '3-room condo, 3 wall units', body: (c) => `General service ${c.money(c.tables.general[2].wall)} per visit; yearly chemical wash ${c.money(c.tables.chemicalWash[2].wall)}.` },
                { title: 'Double-storey terrace, 4 wall units + 1 cassette', body: (c) => `General service for the four wall units ${c.money(c.tables.general[3].wall)}, plus ${c.money(c.tables.general[0].ducted)} for the cassette.` },
                { title: 'Studio or room rental, 1 unit', body: (c) => `${c.money(c.tables.general[0].wall)} per service, or ${c.money(c.tables.annual[0].threeTimes)} a year on a three-service package.` },
            ],
        },
    ],
    faqs: [
        {
            question: 'How much is aircond service in KL?',
            answer: (c) => `${c.money(c.tables.general[0].wall)} for a general service on one wall-mounted unit, ${c.money(c.tables.chemicalWash[0].wall)} for a chemical wash and ${c.money(c.tables.chemicalOverhaul[0].wall)} for a chemical overhaul.`,
        },
        {
            question: 'Is there a transport charge?',
            answer: 'No. Transport within KL and the nearby Klang Valley is included in the price.',
        },
        {
            question: 'Do prices include SST?',
            answer: 'The prices shown are what you pay - nothing is added at booking.',
        },
    ],
    alternates: [
        { hreflang: 'en-my', path: '/my/aircond-service-kuala-lumpur/aircond-service-price' },
        { hreflang: 'ms-my', path: '/my/aircond-service-kuala-lumpur/harga-servis-aircond' },
    ],
    schema: {
        name: 'Aircond Service Prices in Kuala Lumpur',
        serviceType: 'Air conditioner servicing',
        offers: (c) => [
            { name: 'General service, 1 unit', price: c.tables.general[0].wall },
            { name: 'Chemical wash, 1 unit', price: c.tables.chemicalWash[0].wall },
            { name: 'Chemical overhaul, 1 unit', price: c.tables.chemicalOverhaul[0].wall },
            { name: 'R32 gas top up, 1 outdoor unit', price: c.tables.gas.R32.half },
            { name: 'Servicing package, 1 unit, 3 a year', price: c.tables.annual[0].threeTimes },
            { name: 'Repair diagnosis visit', price: c.tables.repairDiagnosis },
        ],
    },
}

export default content
